/**
 * Convert HEX color to HSL tuple string for CSS variables.
 * Returns HSL values without 'hsl()' wrapper, e.g. "171 86% 40%".
 */
export function hexToHSL(hex: string): string {
  hex = hex.replace(/^#/, '')

  const r = parseInt(hex.substring(0, 2), 16) / 255
  const g = parseInt(hex.substring(2, 4), 16) / 255
  const b = parseInt(hex.substring(4, 6), 16) / 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h = 0
  let s = 0
  const l = (max + min) / 2

  if (max !== min) {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6
        break
      case g:
        h = ((b - r) / d + 2) / 6
        break
      case b:
        h = ((r - g) / d + 4) / 6
        break
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`
}

/** Normalize a brand color (hex or HSL tuple) for comparison purposes. */
export function normalizeBrandColorForCompare(color: string | null | undefined): string | null {
  if (!color) return null
  return color.startsWith('#') ? hexToHSL(color) : color
}

export function colorToCssValue(color: string | null | undefined, fallbackCss: string) {
  if (!color) return fallbackCss

  const trimmed = color.trim()
  if (!trimmed) return fallbackCss

  // Accept CSS-native color formats directly.
  if (trimmed.startsWith('#')) return trimmed
  if (/^hsl\(/i.test(trimmed)) return trimmed
  if (/^rgb\(/i.test(trimmed)) return trimmed
  if (/^rgba\(/i.test(trimmed)) return trimmed

  // Our theme tokens store HSL tuples without the wrapper, e.g. "210 80% 40%".
  return `hsl(${trimmed})`
}

